import naja from "naja";
import netteForms from "nette-forms";
import {initFlowbite} from "flowbite";

import S84FormButtonsExtension from "../najaExtensions/s84FormButtonsExtension";
import S84CkeEditor5Extension from "../najaExtensions/s84CkeEditor5Extension";
// import S84DatePickerExtension from "../najaExtensions/s84DatePickerExtension";
import S84ClassToggler from "../najaExtensions/s84ClassToggler";
import S84Recaptcha from "../s84Recaptcha";

//require("fslightbox");
import 'fslightbox';

// import * as FsLightbox from "fslightbox";
import * as CookieConsent from "vanilla-cookieconsent";
import {cookieConfigObj} from "../cookieConfig";
import S84CkeEditor5InlineExtension from "../najaExtensions/s84CkeEditor5InlineExtension";

const Nette = netteForms;
Nette.invalidNumberMessage = 'Prosím, zadejte číslo.';
Object.assign(window, Nette);


naja.uiHandler.selector = '.ajax';
naja.formsHandler.netteForms = netteForms;
naja.registerExtension(new S84FormButtonsExtension());
// naja.registerExtension(new S84CkeEditor5Extension())
// naja.registerExtension(new S84DatePickerExtension())
naja.registerExtension(new S84ClassToggler())
naja.registerExtension(new S84Recaptcha())
naja.registerExtension(new S84CkeEditor5InlineExtension())

netteForms.initOnLoad();

naja.addEventListener('complete', (event) => {
    const payload = event.detail.payload;
    if (payload.snippets !== undefined) {
        for (let i in payload.snippets) {
            if (payload.snippets.hasOwnProperty(i)) {
                const snippet = payload.snippets[i];
                if (snippet.includes('fslightbox')) {
                    window.refreshFsLightbox()
                    return;
                }
            }
        }
    }
});


/**
 * Testuje, zda existuje položka v poli
 * @param elem
 * @param arg
 * @param value
 * @returns {boolean}
 * @constructor
 */
Nette.validators.SasuleComponentsFormValidatorsContainsValue_validateContains = function (elem, arg, value) {
    let myInArray = function (arr, val) {
        if ([].indexOf) {
            return arr.indexOf(val) > -1;
        } else {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === val) {
                    return true;
                }
            }
            return false;
        }


    };
    return myInArray(value, arg);
};

// console.log(Datepicker.prototype.options.monthsFull);


// Datepicker.Config.monthsFull = ['Leden']

window.naja = naja;

document.addEventListener('DOMContentLoaded', () => {
    // initTE({Alert, Collapse, Dropdown})
    initFlowbite();

    naja.initialize()
    naja.addEventListener('complete', () => {
        initFlowbite();
        // initTE({Alert, Collapse, Dropdown})
    });

    CookieConsent.run(cookieConfigObj);

});
